export function getLocalStorageObject({ localStorageKey, objectKey }) {
  const value = window.localStorage.getItem(localStorageKey);

  if (!value) {
    return undefined;
  }

  let obj;

  try {
    obj = JSON.parse(value);
  } catch (_e) {
    console.error(
      `Failed to JSON.parse '${localStorageKey}' from local storage: ${value}`,
    );
    return undefined;
  }

  return obj[objectKey];
}

export function setLocalStorageObject({
  localStorageKey,
  objectKey,
  objectValue,
}) {
  const value = window.localStorage.getItem(localStorageKey);
  let obj;

  try {
    obj = JSON.parse(value) || {};
  } catch (_e) {
    console.error(
      `Failed to JSON.parse '${localStorageKey}' from local storage: ${value}`,
    );
  }

  obj[objectKey] = objectValue;

  window.localStorage.setItem(localStorageKey, JSON.stringify(obj));
}
